import type {EntityLeaderboardRows, OtherLeaderboardRows} from './types';

/**
 * Returns the positions for the leaderboard rows. Ties will be given the same
 * position, otherwise the positions will be consecutive if hasConsecutivePositions is true.
 *
 * @param {EntityLeaderboardRows | OtherLeaderboardRows} rowsData - The rows
 * data to get the positions for.
 * @returns {number[]} - The positions for the leaderboard rows.
 */
export function getLeaderboardPositions(
    rowsData: EntityLeaderboardRows | OtherLeaderboardRows,
    hasConsecutivePositions?: boolean
): number[] {
    // @ts-expect-error
    const positions = [];
    let currentPosition = 1;

    for (let i = 0; i < rowsData.length; i++) {
        // @ts-expect-error
        if (!hasConsecutivePositions && i > 0 && rowsData[i].value === rowsData[i - 1].value) {
            // @ts-expect-error
            positions.push(positions[i - 1]);
        } else {
            positions.push(currentPosition);
        }
        currentPosition++;
    }

    return positions;
}
